
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.136 6.499l6.762 3.854-6.762 3.879V6.498m-.554-1.5c-.345 0-.582.274-.582.744v9.25c0 .47.237.743.58.743a.945.945 0 00.461-.14l8.1-4.65a.628.628 0 000-1.191l-8.1-4.618a.945.945 0 00-.46-.138z"}})])
          )
        }
      }
    